import type { CreateAccountInput } from '@/data/api'

/**
 * Hierarchy `POST /agents` body (OpenAPI CreateAgentRequest).
 * Wizard-only fields (games, betLimits, per-market commission, comments) are not sent.
 */
export interface CreateAgentRequest {
  parentId?: string
  name: string
  creditLimit: string
  shareBp: number
  commissionBp: number
  member: boolean
}

/** Major units (₹) → minor units (paise) as decimal string. */
export function toMinorUnits(major: number): string {
  if (!Number.isFinite(major) || major < 0) return '0'
  return String(Math.round(major * 100))
}

/** Share points 0–100 → basis points 0–10000. */
export function sharePointsToBp(points: number): number {
  if (!Number.isFinite(points) || points < 0) return 0
  return Math.min(10_000, Math.round(points * 100))
}

/** Commission percent display value (e.g. 0.96 for 0.96%) → basis points. */
export function commissionPercentToBp(percent: number): number {
  if (!Number.isFinite(percent) || percent < 0) return 0
  return Math.min(10_000, Math.round(percent * 100))
}

export function toCreateAgentRequest(
  input: CreateAccountInput,
  parentId: string,
): CreateAgentRequest {
  return {
    parentId,
    name: input.displayName.trim() || input.username.trim(),
    creditLimit: toMinorUnits(input.creditLimit),
    shareBp: sharePointsToBp(input.share),
    commissionBp: commissionPercentToBp(input.commission.fancy),
    member: input.role === 'player',
  }
}
